import { Link, useParams } from 'react-router-dom';
import Layout from "../components/Layout";
import projects from '../data/projects';

const Project = () => {

    let { id } = useParams();

    const project = projects.find(item => item.id === id)

    if (!project) {
        return (
        <Layout>
            <Link to = '/projects' className="back-link">← All projects</Link>
            <h1 className="page-title">Project not found</h1>
            <p className="lede">That project doesn't exist - have a look at the projects page instead.</p>
        </Layout>
        )
    }

    return (
    <Layout>
        <Link to = '/projects' className="back-link">← All projects</Link>
        <div className="project-detail">
            <div>
                <p className="eyebrow">Project</p>
                <h1 className="page-title">{project.name}</h1>
                <p className="lede">{project.tagline}</p>
                <ul className="chips">
                    {project.tech.map(item => <li className="chip" key = {item}>{item}</li>)}
                </ul>
                <div className="project-body">
                    <h2>About</h2>
                    <p>{project.description}</p>
                </div>
                {project.website || project.repo ? (
                <div className="project-links">
                    {project.website ? <a href = {project.website} className="button button-primary">Website</a> : null}
                    {project.repo ? <a href = {project.repo} className="button">Repo</a> : null}
                </div>
                ) : null}
            </div>
            {project.screenshots ? (
            <div className="screenshots">
                {project.screenshots.map((src, idx) => <img key = {idx} src = {src} alt = {`${project.name} screenshot ${idx + 1}`}/>)}
            </div>
            ) : null}
        </div>
    </Layout>
    );
}

export default Project;
